	$(function() {
		// 獲得予定ポイント計算
		// 読み込み時
		$("select[name='refund_rate']").each(function() {
				const magnification = $(this).val();
				var oPoint = $(this).closest('form.form-simple').find(".js-point-value").val();
				var oPoint = oPoint * magnification / 100;
				// 小数点以下切り捨て
				var oPoint = Math.floor(oPoint);
				$(this).closest('form.form-simple').find('.js-point').html('<span class="point-value">' + oPoint + '</span><span class="point-mark">P</span>');
		});
		// ポイント還元率変更時
		$("select[name='refund_rate']").on('change', function() {
				const magnification = $(this).val();
				var oPoint = $(this).closest('form.form-simple').find(".js-point-value").val();
				var oPoint = oPoint * magnification / 100;
				// 小数点以下切り捨て
				var oPoint = Math.floor(oPoint);
				$(this).closest('form.form-simple').find('.js-point').html('<span class="point-value">' + oPoint + '</span><span class="point-mark">P</span>');
		});
	});